import { FC, useCallback, useState } from 'react'

import { LoaderOverlay } from 'core-components/library/loader'

import { downloadAplDocument } from '../../../../api/downloadAplDocument'
import { IAplDocument } from '../../../../models/aplDocument'

import { ListItem } from './components/listItem/ListItem'

import styles from './DocumentsList.module.scss'

interface IDocumentsListProps {
  label: string
  documents: IAplDocument[]
}

export const DocumentsList: FC<IDocumentsListProps> = ({ documents, label }) => {
  const [isLoading, setIsLoading] = useState(false)

  const handleDocumentClick = useCallback(async (document: IAplDocument) => {
    setIsLoading(true)
    await downloadAplDocument({
      documentId: document.id,
      fileName: document.FileName,
    })
    setIsLoading(false)
  }, [])

  return (
    <div className={styles.documentsWrapper}>
      <LoaderOverlay show={isLoading} />
      <div className={styles.documentTypeLabel}>{label}</div>
      <div className={styles.listWrapper}>
        {documents.map((it) => (
          <div key={it.id}>
            <ListItem document={it} onClick={handleDocumentClick} />
          </div>
        ))}
      </div>
    </div>
  )
}
